import {Inline, Stack} from '@pleo-io/telescope'

import {SkeletonLoader} from '~/generic-ui/skeleton-loader/skeleton-loader'

import {AvatarContainer, Header, Wrapper} from './subscription-expense-details-loader.styles'

export const SubscriptionExpenseDetailsLoader = () => (
    <Wrapper>
        <Header />

        <Inline justifyContent="center" mb={52}>
            <AvatarContainer>
                <SkeletonLoader height={72} width={72}>
                    <circle cx={36} cy={36} r={36} />
                </SkeletonLoader>
            </AvatarContainer>
        </Inline>

        <Stack space={16} justifyContent="center" justifyItems="center" mb={32}>
            <SkeletonLoader width={120} height={20}>
                <rect x="0" y="0" width="120" height="20" rx="4" />
            </SkeletonLoader>
            <SkeletonLoader width={150} height={30}>
                <rect x="0" y="0" width="150" height="30" rx="4" />
            </SkeletonLoader>
            <SkeletonLoader width={92} height={12}>
                <rect x="0" y="0" width="92" height="12" rx="4" />
            </SkeletonLoader>
        </Stack>

        <Inline justifyContent="center" py={24} px={32} mb={48}>
            <SkeletonLoader width={350} height={12}>
                <rect x="0" y="0" rx="4" width="350" height="12" />
            </SkeletonLoader>
        </Inline>

        <Stack space={40} justifyContent="center" px={32}>
            <SkeletonLoader width={500} height={52} repeatPattern={4}>
                <circle cx="20" cy="25" r="20" />
                <rect x="64" y="6" rx="4" width="108" height="18" />
                <rect x="64" y="34" rx="4" width="216" height="12" />
                <rect x="394" y="14" rx="4" width="106" height="20" />
            </SkeletonLoader>
        </Stack>
    </Wrapper>
)
